import { InputMask } from "@react-input/mask";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Button from "@/atomic/atoms/Button";
import Modal from "@/atomic/atoms/Modal";
import Loading from "@/atomic/atoms/Loading";

export default function MyDataView({
  goBack,
  customer,
  onChange,
  submit,
  isDisabled,
  setZipcode,
  address,
  phone,
  email,
  setCity,
  setComplement,
  setNeighborhood,
  setNumber,
  setState,
  setStreetName,
  setEmail,
  setPhone,
  editable,
  success,
  error,
  setError,
  isLoading,
  setErrorZipcode,
  errorZipcode,
  setSuccess,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Meus dados"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div>
            <h2 className="mt-6 text-black text-xl">Dados cadastrais</h2>
            <h3 className="text-black text-sm">Altere os dados do seu acesso.</h3>
            <div className="flex flex-col justify-center items-center">
              <InputMask 
                name="document"
                defaultValue={customer?.client?.document?.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4") ?? ""}
                required 
                type="text"
                inputMode="numeric"
                mask="___.___.___-__"
                replacement={{ _: /\d/ }}
                disabled
                placeholder="Seu CPF"
                className="mt-5 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <input 
                defaultValue={customer?.client?.name ?? ""}
                required 
                type="text" 
                name="name" 
                disabled
                placeholder="Nome completo" 
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <InputMask 
                value={phone}
                name="phone"
                required 
                onChange={(event) => onChange(setPhone, event)} 
                type="text"
                inputMode="numeric"
                mask="(__) _____-____"
                replacement={{ _: /\d/ }}
                placeholder="Celular"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <input 
                value={email}
                required 
                onChange={(event) => onChange(setEmail, event)} 
                type="text" 
                inputMode="email"
                name="email" 
                placeholder="E-mail"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14" 
              />
              <InputMask 
                value={address?.zipcode ?? ""}
                name="zipcode"
                required 
                onChange={(event) => onChange(setZipcode, event)} 
                type="text"
                inputMode="numeric"
                mask="_____-___"
                replacement={{ _: /\d/ }}
                placeholder="Seu CEP"
                className="mt-5 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <div className="w-full flex flex-row justify-between items-center">
                <input 
                  value={address?.streetName ?? ""}
                  required 
                  onChange={(event) => onChange(setStreetName, event)} 
                  type="text" 
                  name="streetName" 
                  placeholder="Logradouro" 
                  disabled={!editable}
                  className="mt-3 text-base text-black w-[calc(65%)] bg-transparent border p-2 rounded-lg h-14"
                />
                <input 
                  value={address?.number ?? ""}
                  required 
                  onChange={(event) => onChange(setNumber, event)} 
                  type="text" 
                  name="number" 
                  placeholder="Nº" 
                  className="mt-3 text-base text-black w-[calc(34%)] bg-transparent border p-2 rounded-lg h-14"
                />
              </div>
              <input 
                value={address?.complement ?? ""}
                required 
                onChange={(event) => onChange(setComplement, event)} 
                type="text" 
                name="complement" 
                placeholder="Complemento" 
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <input 
                value={address?.neighborhood ?? ""}
                required 
                onChange={(event) => onChange(setNeighborhood, event)} 
                type="text" 
                name="neighborhood" 
                placeholder="Bairro" 
                disabled={!editable}
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <div className="w-full flex flex-row justify-between items-center">
                <input 
                  value={address?.city ?? ""}
                  required 
                  onChange={(event) => onChange(setCity, event)} 
                  type="text" 
                  name="city" 
                  placeholder="Cidade" 
                  disabled={!editable}
                  className="mt-3 text-base text-black w-[calc(65%)] bg-transparent border p-2 rounded-lg h-14"
                />
                <InputMask 
                  value={address?.state ?? ""}
                  name="state"
                  required 
                  onChange={(event) => onChange(setState, event)} 
                  type="text"
                  mask="__"
                  replacement={{ _: /\D/ }}
                  placeholder="UF"
                  disabled={!editable}
                  className="uppercase mt-3 text-base text-black w-[calc(34%)] bg-transparent border p-2 rounded-lg h-14"
                />
              </div>
            </div>
          </div>
          <Button 
            title="Atualizar"
            onClick={submit}
            type="submit"
            isDisabled={isDisabled}
          />
        </article>
      </main>
      {success && <Modal 
        title="Tudo certo!"
        message="Seus dados foram atualizados com sucesso."
        actionMessage="Ok"
        action={() => setSuccess(false)}
      />}
      {error && <Modal 
        title="Ops!"
        message="Não foi possível atualizar seus dados. Deseja tentar novamente?"
        actionMessage="Sim"
        action={submit}
        actionSecondMessage="Não"
        actionSecond={() => setError(false)}
      />}
      {errorZipcode && <Modal 
        title="Atenção"
        message="Cep inválido"
        actionMessage="Usar outro cep"
        action={() => setErrorZipcode(false)}
      />}
      {isLoading && <Loading />}
    </div>
  );
}
